export const OPEN_VENUE_REGISTER_MODAL = 'OPEN_VENUE_REGISTER_MODAL';
export const OPEN_VENDOR_REGISTER_MODAL = 'OPEN_VENDOR_REGISTER_MODAL';

export const CLOSE_REGISTER_MODAL = 'CLOSE_REGISTER_MODAL';

export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL';
